import { styled, Theme, Typography } from "@mui/material";
import { IStyledTypographyProps } from "./types";

const pickColor = (theme?: Theme) => ({
    primary: (theme as any).palette?.neutral?.lighter,
    secondary: (theme as any).palette?.neutral?.darkest,
    tertiary: (theme as any).palette?.primary?.darker,
    quaternary: (theme as any).palette?.secondary?.main,
    success: (theme as any).palette?.accentSuccess?.main
})
const StyledTypography = styled(Typography)<IStyledTypographyProps>(({ theme, color = "primary" }) => ({
    // use theme fontFamily so the global Satoshi font applies consistently
    color: pickColor(theme)[color],
    fontFamily: (theme as any).typography?.fontFamily,
    // size variants
    "&.MuiTypography-xs": {
        lineHeight: (theme as any).typography.lineHeights?.xs,
        fontSize: (theme as any).typography.sizes?.xs,
        fontWeight: (theme as any).typography.weights?.regular
    },
    "&.MuiTypography-sm": {
        lineHeight: (theme as any).typography.lineHeights?.sm,
        fontSize: (theme as any).typography.sizes?.sm,
        fontWeight: (theme as any).typography.weights?.regular
    },
    "&.MuiTypography-md": {
        lineHeight: (theme as any).typography.lineHeights?.md,
        fontSize: (theme as any).typography.sizes?.md,
        fontWeight: (theme as any).typography.weights?.regular
    },
    "&.MuiTypography-lg": {
        lineHeight: (theme as any).typography.lineHeights?.lg,
        fontSize: (theme as any).typography.sizes?.lg,
        fontWeight: (theme as any).typography.weights?.regular
    },
    "&.MuiTypography-xl": {
        lineHeight: (theme as any).typography.lineHeights?.xl,
        fontSize: (theme as any).typography.sizes?.xl,
        fontWeight: (theme as any).typography.weights?.regular
    },

    // body variant
    "&.MuiTypography-body1": {
        lineHeight: (theme as any).typography.lineHeights?.body,
        fontSize: (theme as any).typography.sizes?.body,
        fontWeight: (theme as any).typography.weights?.regular
    },

    // heading variants
    "&.MuiTypography-h1": {
        lineHeight: (theme as any).typography.lineHeights?.h1,
        fontSize: (theme as any).typography.sizes?.h1,
        fontWeight: (theme as any).typography.weights?.bold
    },
    "&.MuiTypography-h2": {
        lineHeight: (theme as any).typography.lineHeights?.h2,
        fontSize: (theme as any).typography.sizes?.h2,
        fontWeight: (theme as any).typography.weights?.bold
    },
    "&.MuiTypography-h3": {
        lineHeight: (theme as any).typography.lineHeights?.h3,
        fontSize: (theme as any).typography.sizes?.h3,
        fontWeight: (theme as any).typography.weights?.bolder
    },
    "&.MuiTypography-h4": {
        lineHeight: (theme as any).typography.lineHeights?.h4,
        fontSize: (theme as any).typography.sizes?.h4,
        fontWeight: (theme as any).typography.weights?.bold
    },
    "&.MuiTypography-h5": {
        lineHeight: (theme as any).typography.lineHeights?.h5,
        fontSize: (theme as any).typography.sizes?.h5,
        fontWeight: (theme as any).typography.weights?.bolder
    },
    "&.MuiTypography-h6": {
        lineHeight: (theme as any).typography.lineHeights?.h6,
        fontSize: (theme as any).typography.sizes?.h6,
        fontWeight: (theme as any).typography.weights?.regular
    },
    "&.MuiTypography-caption":{
        lineHeight: (theme as any).typography.lineHeights?.caption,
        fontSize: (theme as any).typography.sizes?.caption,
        fontWeight: (theme as any).typography.weights?.regular
    }
}))

export {StyledTypography}